import React from 'react';
import { AlertCircleIcon, CheckIcon, XIcon } from 'lucide-react';
interface WizardChromeProps {
  title: string;
  steps: string[];
  currentStep: number;
  onClose: () => void;
}
export function WizardChrome({
  title,
  steps,
  currentStep,
  onClose
}: WizardChromeProps) {
  return <header className="flex flex-wrap items-center justify-between gap-4 border-b border-ink-200 bg-white px-6 py-4" data-id="element-426" data-mp="1h6te0o451s8o">
      <div className="flex items-center gap-3" data-id="element-427" data-mp="jk48436bevhj">
        <button type="button" onClick={onClose} aria-label="Close wizard" className="rounded p-1 text-ink-500 hover:bg-ink-100 hover:text-ink-700" data-id="element-428" data-mp="jlfbi1vum184">
          <XIcon className="h-4 w-4" data-id="element-429" data-mp="tjlaaamcyr8r" />
        </button>
        <h1 className="text-[17px] font-bold text-ink-900" data-id="element-430" data-mp="xjc64sqqrxk5">{title}</h1>
      </div>

      <ol className="flex items-center gap-3" data-id="element-431" data-mp="24x6xhq8nqirn">
        {steps.map((step, index) => {
        const number = index + 1;
        const done = number < currentStep;
        const active = number === currentStep;
        return <li key={step} className="flex items-center gap-3" data-id="element-432" data-mp="3ft3z6bvduxza" data-mpi={index}>
              {index > 0 && <span className="h-px w-6 bg-ink-300" aria-hidden="true" data-id="element-433" data-mp="3avklbd2lkn7v" />}
              <span className="flex items-center gap-2" data-id="element-434" data-mp="35v6etzgn9lby">
                <span className={`flex h-5 w-5 items-center justify-center rounded-full text-[11px] font-bold ${done ? 'bg-emerald-500 text-white' : active ? 'bg-brand-600 text-white' : 'border border-ink-300 text-ink-400'}`} data-id="element-435" data-mp="35tmxe5j9548l">
                  {done ? <CheckIcon className="h-3 w-3" data-id="element-436" data-mp="2n2vp77b03jvs" /> : number}
                </span>
                <span className={`text-[13px] ${active ? 'font-semibold text-ink-900' : 'text-ink-500'}`} data-id="element-437" data-mp="2i7gg0snxuc5p">
                  {step}
                </span>
              </span>
            </li>;
      })}
      </ol>
    </header>;
}
interface WizardFooterProps {
  counter?: React.ReactNode;
  children: React.ReactNode;
}
export function WizardFooter({
  counter,
  children
}: WizardFooterProps) {
  return <div className="sticky bottom-0 z-10 flex items-center justify-end gap-4 border-t border-ink-200 bg-white px-6 py-3" data-id="element-438" data-mp="1pjngyh9uxktd">
      {counter}
      {children}
    </div>;
}
export function DeviceCounter({
  count,
  max,
  complete
}: {
  count: number;
  max: number;
  complete: boolean;
}) {
  return <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[12.5px] font-medium ${complete ? 'bg-emerald-50 text-emerald-700' : 'bg-red-50 text-red-600'}`} data-id="element-439" data-mp="2n6w6qogw5g16">
      {complete ? <span className="flex h-4 w-4 items-center justify-center rounded-full bg-emerald-500 text-white" data-id="element-440" data-mp="2dgb0ceuz777p">
          <CheckIcon className="h-2.5 w-2.5" data-id="element-441" data-mp="3165auprtojos" />
        </span> : <AlertCircleIcon className="h-4 w-4" data-id="element-442" data-mp="35y5cqnrgdmo0" />}
      {count} of {max} Devices Added
    </span>;
}